import { KEY } from '@/common/const.js';

export function getLocalUserInfo() {
    const val = localStorage.getItem(KEY);
    if (!val) {
        return false;
    }
    const obj = JSON.parse(val)
    if (!obj) {
        return false;
    }
    return obj;
}

export function clearLocal() {
    return  localStorage.clear();
}
